import { useAuthStore } from "@/store/useAuthStore";

// Manager assumes daily_report_mode is on. With the flag off, a manager
// falls back to the full sidebar and will see write actions on owner-only
// pages (master data, payables, etc.) that the backend rejects with 403.
// Tightening these per-page gates is deferred to a follow-up PR.
export function useDailyReportMode(): boolean {
  const farm = useAuthStore((s) => s.farm);
  const user = useAuthStore((s) => s.user);
  const inWizardRole = user?.role === "supervisor" || user?.role === "manager";
  return inWizardRole && !!farm?.features?.daily_report_mode;
}
